import React, { useEffect } from 'react';
import { Title, Meta, Link } from 'react-head';
import styles from './LPOFinancing.module.css';

// Import section components
import HeroSectionLPO from './HeroSectionLPO/HeroSectionLPO';
import IntroductionSection from './IntroductionSection/IntroductionSection';
import HowItWorksSection from './HowItWorksSection/HowItWorksSection';
import EligibilitySection from './EligibilitySection/EligibilitySection';
import BenefitsSection from './BenefitsSection/BenefitsSection';
import DocumentsSection from './DocumentsSection/DocumentsSection';
import CTASection from './CTASection/CTASection';

const LPOFinancing = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'LPO Financing, Capital Financing & Business Line of Credit';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) metaDescription.setAttribute('content', 'Explore LPO financing solutions to support business growth with flexible funding, including purchase order financing and tailored capital loans.');
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) metaKeywords.setAttribute('content', 'LPO Financing, Business Loans, Purchase Order Financing, Business line of credit, Contract financing, Commercial business loan, Purchase order, Business financing, Business capital loans, Trinity Financing');
  }, []);

  return (
    <>
      {/* SEO Meta Tags */}
      <Title>LPO Financing, Capital Financing & Business Line of Credit</Title>
      
      <Meta name="description" content="Explore our LPO Financing solutions to support your business growth with flexible and reliable financing options. Get purchase order financing and business capital loans." />
      
      <Meta name="keywords" content="LPO Financing, Business Loans, Purchase Order Financing, Business line of credit, Contract financing, Commercial business loan, Purchase order, Business financing, Business capital loans, Trinity Financing" />
      
      <Meta name="robots" content="index, follow" />
      <Meta name="author" content="Trinity Financing" />
      
      <Link rel="canonical" href="https://trinityfinancing.com/lpofinancing" />
      
      {/* Open Graph Tags */}
      <Meta property="og:type" content="website" />
      <Meta property="og:url" content="https://trinityfinancing.com/lpofinancing" />
      <Meta property="og:title" content="LPO Financing | Capital Financing | Business Line of Credit" />
      <Meta property="og:description" content="Explore our LPO Financing solutions to support your business growth with flexible and reliable financing options." />
      <Meta property="og:image" content="https://trinityfinancing.com/micro-finance.jpg" />
      <Meta property="og:image:width" content="1200" />
      <Meta property="og:image:height" content="630" />
      <Meta property="og:site_name" content="Trinity Financing" />
      
      {/* Twitter Card Tags */}
      <Meta name="twitter:card" content="summary_large_image" />
      <Meta name="twitter:title" content="LPO Financing | Capital Financing | Business Line of Credit" />
      <Meta name="twitter:description" content="Explore our LPO Financing solutions to support your business growth with flexible and reliable financing options." />
      <Meta name="twitter:image" content="https://trinityfinancing.com/micro-finance.jpg" />

      {/* Page Content */}
      <div className={styles.container}>
        <HeroSectionLPO />
        <IntroductionSection />
        <HowItWorksSection />
        <EligibilitySection />
        <BenefitsSection />
        <DocumentsSection />
        <CTASection />
      </div>
    </>
  );
};

export default LPOFinancing;